<template>
  <div v-if="dataLoaded">
    <c-panel>
      <div class="u-h5">Batches</div>
      <c-row :key="d.code" v-for="d in data">
        <div v-if="d.ui_component !== null">
          <c-col offset="1">
            <a @click.prevent="onExecuteBatch(d.code)" href="#">{{d.display_name}}</a>
            <component :is="d.ui_component" :ref="d.code"></component>
          </c-col>
        </div>
      </c-row>
    </c-panel>
  </div>
</template>

<script>
  import batches from '../../services/batches.service'
  import {mapState} from 'vuex'

  export default {
    name: 'Batches',
    computed: {
      ...mapState('auth', ['clientCode', 'clientId'])
    },

    data () {
      return {
        data: [],
        dataLoaded: false
      }
    },

    created () {
      batches.getBatchTypes(this.clientCode).then((response) => {
        this.data = response.data
        this.dataLoaded = true
      }).catch(_ => {
        // maybe report the error ???
        // this.dataLoaded = true
      })
    },

    methods: {
      onExecuteBatch (code) {
        console.log('Execute batch: ' + code)
        this.$refs[code][0].run(null, null)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Batches/Batches.vue